<style lang="scss" src='./CourseStationList.scss' scoped></style>
<template src="./CourseStationList.html"></template>

<script>
  import { deleteWeatherStationById } from '@/api/index';
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import { mapMutations, mapState } from 'vuex';
  
  import { Models } from 'gw-js-lib';
  
  export default {
    name: 'CourseStationList',
    components: {
    },

    data() {
      return {
        stations: []
      };
    },

    computed: {
      ...mapState('CourseSetup', {
        course: (state) => state.setupData.course,
        stationsStore: (state) => state.setupData.stations,
        loading: (state) => state.loading,
      }),
    },

    watch: {
      stationsStore() {
        this.stations = [...this.stationsStore];
      },
    },

    methods: {
      
      async continue() {
        return true;
      },

      goToAddNewStation() {
        this.setStationSelected(null);
        this.setEditingStation(false);
        this.setShowNewStationPage(true);
      },

      goToEditStation(index) {
        const station = this.stations[index];
        this.setStationSelected(station);
        this.setEditingStation(true);
        this.setShowNewStationPage(true);
      },

      fnDeleteStation(index) {
        if (this.course && this.course.course_id) {
          this.G_Alert_v2({ style: this.consts.Style.DANGER, 
                            message: this.$t('weatherStation.delStationConfirm'),
                            fnOk: () => {
                              deleteWeatherStationById(this.stations[index].station_id)
                              .then(() => {
                                this.deleteStation(index);
                              });
                            }
                          });
        } else {
          this.deleteStation(index);
        }
      },

      loadData() {
        this.stations = [...this.stationsStore];
      },

      ...mapMutations('CourseSetup', ['setCanContinue', 'setCanBack', 'setSetupData', 'setLoading',
                                      'setShowNewStationPage', 'setStationSelected', 'setEditingStation',
                                      'deleteStation']),
    },

    activated() {
      this.setCanContinue(this.continue);
      this.setCanBack(null);
    },

    mounted() {
      this.loadData();
    },

    beforeDestroy() {
    },
  };

</script>
